import axios from "axios";

/**
 * @param {string} api - e.g. from App `API` (…/api)
 * @param {string} inviteCode
 * @returns {Promise<string>} project id
 */
export async function joinProjectByInvite(api, inviteCode) {
  const inv = String(inviteCode || "").trim();
  if (!inv) throw new Error("missing_invite");
  const { data } = await axios.post(`${api}/projects/join`, { invite_code: inv });
  if (!data?.id) throw new Error("join_no_id");
  return data.id;
}

export function buildInviteLink(inviteCode) {
  const code = String(inviteCode || "").trim();
  if (!code || typeof window === "undefined") return "";
  const base = window.location.origin.replace(/\/+$/, "");
  return `${base}/join/${encodeURIComponent(code)}`;
}
